import React, { useEffect, useState } from "react";
import httpService from "../../../services/http/peoples/company.service";
import { Link, useNavigate, useParams } from "react-router-dom";
import notificationService from "../../../services/toaster.service";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import UnlimitFieldDetails from "../../../components/ui-kit/unlimit-field-details";
import UnlimitLoading from "../../../components/ui-kit/unlimit-loading";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import UnlimitTable from "../../../components/ui-kit/unlimit-table";
import ConfirmationAlertDeactivate from "../../../components/confirm-deactivate";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../../utils/permissionFunction";
import { Collapse } from "antd";
import UnlimitToggle from "../../../components/ui-kit/unlimit-toggle-2";
import { Plus } from "feather-icons-react/build/IconComponents";
import CompanyAccountForm from "../../../components/company/copmany-account-form";
import ConfirmationAlert from "../../../components/confirm-alert";
import Swal from "sweetalert2";

const CompanyDetails = () => {
  const { hasPermission } = useRoleAndPerm();
  const [pageLoading, setPageLoading] = useState(false);
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const { t } = useTranslation();
  const [selectedAccount, setSelectedAccount] = useState(null);

  const createSubAccount = async (data) => {};
  const getCompany = async () => {
    setSelectedAccount(null);
    try {
      setPageLoading(true);
      await httpService
        .getCompany(id)
        .then(async (response) => {
          if (response && response.status == 200) {
            setCompany(response.data.data);
            setIsActive(response.data.data.is_active == 0 ? true : false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    getCompany();
  }, [id]);

  const onChangeCompanyAccountStatus = async (accountId, checked) => {
    const requestData = {
      is_active: checked ? 1 : 0,
      company_id: id,
    };
    await httpService
      .updateCompanyAccount(requestData, accountId)
      .then((response) => {
        if (response.status === 200) {
          notificationService.successMessage(t("company.companyUpdateSuccess"));
          getCompany();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const updateCompany = async () => {
    const requestData = {
      is_active: isActive ? 1 : 0,
      id: id,
    };
    await httpService
      .updateCompany(requestData, true)
      .then((response) => {
        if (response.status === 200) {
          notificationService.successMessage(t("company.companyUpdateSuccess"));
          setIsActive(!isActive);
          getCompany();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const onClickEditCompanyAccount = (subAccount) => {
    setSelectedAccount(subAccount);
    const btnEdit = document.querySelector(".btn-add-sub-account");
    if (btnEdit) {
      btnEdit.click();
    }
  };

  const onConfirmDelete = async (id) => {
    await httpService
      .deleteCompanyAccount(id)
      .then((response) => {
        if (response.status == 200) {
          Swal.fire({
            title: t("general.prompts.deleted"),
            text: t("company.CompanyDeleteSuccess"),
            className: "btn btn-success",
            confirmButtonText: t("general.button.ok"),
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          getCompany();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t("company.company"), link: "/companies-list" },
    { label: t("company.viewCompany"), active: true },
  ];

  // Sub-Account table columns
  const subAccountColumns = [
    {
      title: t("tableColumnName.srNo"),
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: t("tableColumnName.lmAccountNo"),
      dataIndex: "lm_account_number",
      key: "account_number",
    },
    {
      title: t("tableColumnName.lmAccountName"),
      dataIndex: "account_name",
      key: "account_name",
    },
    {
      title: t("tableColumnName.adminName"),
      dataIndex: "admin_name",
      key: "admin_name",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <span>{record?.admin?.name}</span>
        </div>
      ),
    },
    {
      title: t("tableColumnName.associateShop"),
      dataIndex: "shops_count",
      key: "shops_count",
    },
    {
      title: t("tableColumnName.associateEmployee"),
      dataIndex: "shoppers_count",
      key: "shoppers_count",
    },
    {
      title: t("tableColumnName.noteRemarks"),
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: t("tableColumnName.status"),
      dataIndex: "is_active",
      key: "is_active",
      hide: !hasPermission(["company-edit"]),
      render: (value, record) => (
        <div className="status-toggle">
          <UnlimitToggle
            isActive={value == 1}
            label=""
            toggleActive={(checked) =>
              onChangeCompanyAccountStatus(record.id, checked)
            }
            id="is_active"
          />
        </div>
      ),
    },
    {
      title: t("tableColumnName.actions"),
      key: "actions",
      hide: !hasPermission(["company-edit"]),
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <a
              className="p-2"
              onClick={() => onClickEditCompanyAccount(record)}
            >
              <i className="feather-edit-2 text-black"></i>
            </a>
            <ConfirmationAlert onConfirm={() => onConfirmDelete(record.id)} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <UnlimitBreadcrumb items={breadcrumbItems} />
            </div>
          </div>
        </div>

        {pageLoading ? (
          <div className="row d-flex justify-content-center">
            <UnlimitLoading width={50} height={50} />
          </div>
        ) : (
          company && (
            <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <div className="card-body">
                    <div className="text-end mb-3">
                      <span
                        className={`badge ${
                          !isActive ? "badge-success" : "badge-danger"
                        }`}
                      >
                        {!isActive
                          ? t("general.actions.active")
                          : t("general.actions.inactive")}
                      </span>
                    </div>
                    <div className="w-100 d-flex flex-column justify-content-center align-items-center h-75 mt-4">
                      <ImageWithBasePath
                        src={company?.logo}
                        height={120}
                        width={120}
                        type="link"
                        alt="Company Logo"
                        className="mb-3"
                      />
                      <h4 className="mb-1">{company?.business_name}</h4>
                      <p className="text-muted">
                        LM Company No: {company?.lm_company_number}
                      </p>
                    </div>
                    {hasPermission(["company-edit"]) && (
                      <div className="d-flex gap-2 mt-3">
                        <button
                          onClick={() =>
                            navigate(`/company/${company?.id}/edit`)
                          }
                          className="btn btn-secondary flex-grow-1"
                        >
                          {t("general.button.edit")}
                        </button>
                        {!isActive ? (
                          <button
                            onClick={updateCompany}
                            className="btn btn-danger flex-grow-1"
                          >
                            {t("general.button.deactivate")}
                          </button>
                        ) : (
                          <button
                            onClick={updateCompany}
                            className="btn btn-success flex-grow-1"
                          >
                            {t("general.button.activate")}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-8">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.adminName")}
                          details={company?.user?.name || ""}
                        />
                      </div>
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.adminPhone")}
                          details={company.phone || ""}
                        />
                      </div>
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.adminEmail")}
                          details={company.email || ""}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-8">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.address")}
                          details={company.address || ""}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.zipCode")}
                          details={company.zip || ""}
                        />
                      </div>
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.city")}
                          details={company.city?.name || ""}
                        />
                      </div>
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.country")}
                          details={company.country?.name || ""}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.createdBy")}
                          details={company.created_by?.name || "Admin"}
                        />
                      </div>
                      <div className="col-md-8">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.createdAt")}
                          details={
                            company.created_at
                              ? moment(company.created_at).format(
                                  "DD MMM YYYY - HH:mm:ss"
                                )
                              : ""
                          }
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <UnlimitFieldDetails
                          heading={t("inputField.label.description")}
                          details={company.description || ""}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub-Account Section */}
              <div className="col-12 mt-4">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4>{t("company.subAccount")}</h4>
                      {hasPermission(["company-edit", "company-add"]) && (
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#add-sub-account"
                          className="btn btn-added btn-add-sub-account"
                        >
                          <Plus className="mr-1 iconsize" />
                          {t("general.button.addNew")}
                        </Link>
                      )}
                    </div>

                    <div className="table-responsive">
                      <UnlimitTable
                        columns={subAccountColumns}
                        dataSource={company?.company_accounts || []}
                        rowKey="id"
                        pagination={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}

        <CompanyAccountForm
          accountId={selectedAccount?.id}
          onHide={() => getCompany()}
          companyId={id}
          createSubAccount={createSubAccount}
        />
      </div>
    </div>
  );
};

export default CompanyDetails;
